export interface IModelBase {
  ID: string;
}

export interface IModel extends IModelBase {
  Name: string;
}

export interface ISelectModel {
  key: string;
  text: string;
}

export function updateModel<T extends IModelBase>(rows: T[], updates: T): T[] {
  return rows.map((r: T) => {
    if (r.ID === updates.ID) {
      return {
        ...r,
        ...updates,
      };
    }
    return r;
  });
}
